import React, { useEffect } from 'react';
import { gsap } from 'gsap/dist/gsap';
import Image from 'next/image';
import bgImage from '../../../../public/images/home-section3.jpg';
import mbImage from '../../../../public/images/mobile/section3.jpg';
import SectionBg from '../sectionBg';
import styles from './section3.module.scss';
import buttonBg from '../../../../public/images/button-bg.png';
import toasterImage from '../../../../public/images/toasters/toaster.png';
import Link from 'next/link';
// Import Swiper Use
import {  useSwiperSlide } from 'swiper/react';
import playClick from '../../actions/default-click';
import playHover from '../../actions/default-hover';
import Quote from '../../icons/quote';
import Question from '../../icons/question';
import Arrow from '../../icons/arrow';
import toasterSound from '../../actions/toasterSound';

function Section3() {
  const screenWidth = window.innerWidth;
  let pageBG = screenWidth < 767 ? mbImage : bgImage;
  const bgData = {
      bgImage: pageBG
  }
  const pageData = {
    title: 'אנחנו לא היינו הילדים היחידים שהתחבאו.',
    content: 'אלו היו הסיפורים שלנו, שרה ורות,  כמונו היו אלפי ילדים, תינוקות, נערים ונערות מכל מיני מקומות. לכל אחד מהם היה סיפור משלו.'
  }
  // Animations
  const swiperSlide = useSwiperSlide();
  // GSAP Split text
  useEffect(() => { 
    if(document.querySelector('.toasterBox')) {
      gsap.set('.toasterBox', {scale: 0, opacity: 0});
    }
      if(swiperSlide.isActive){
          gsap.set('.title', {y: 100, opacity: 0}); 
          gsap.set('.content', {y: 100, opacity: 0}); 
          gsap.set('.button', {y: 100, opacity: 0});
          gsap.set('.bottom', {y: 100, opacity: 0});
          if(document.querySelector('.mobileToaster')) {
            gsap.set('.mobileToaster', {y: 100, opacity: 0});
          }
          gsap.to('.title', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay:0 })
          gsap.to('.content', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay:0.3 })
          gsap.to('.button', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay:0.6 })
          gsap.to('.bottom', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay:0.9 })
          gsap.to('.mobileToaster', {y:0, opacity: 1, ease:"ease.inOut", duration: 1, delay: 1 });
          // Popup Toaster
          setTimeout(function() {
            gsap.to('.toasterBox', {scale:1, opacity: 1, ease:"ease.inOut", duration: 0.5, delay:0 })
            toasterSound();
          }, 1000);
      }
  }, [swiperSlide.isActive]);
  // Redirect page
  /* const redirectPage = () => {
    setTimeout(function() {
      window.location.replace("/story");
    }, 500);
    //window.location.replace("/front-end/story");
  } */
  return (
    <>
      <SectionBg data={bgData} />
      <div className={`section-wrapper z-20 ${styles.wrapper}`}>
          <div className='section-top'>
            <h2 className={`title ${styles.title}`}>{pageData.title}</h2>
            <div className={`content ${styles.content}`} >
              <p>{pageData.content}</p>
            </div>
          </div>

          {screenWidth > 767 && (
            <div className={`bottom relative flex items-center ${styles.infoBox}`}>
              <div className={`${styles.toasterImage}`}>
                <Image 
                  width={toasterImage.width}
                  height={toasterImage.height}
                  blurDataURL={toasterImage?.blurDataURL}
                  placeholder={'blur'}
                  className={`inline-block`} 
                  src={toasterImage.src} alt="" />
              </div>
              <div className={`toasterBox ${styles.toasterContent} absolute bottom-0 right-full mr-5`}>
                <div className={`${styles.right} mb-5`}>
                  <h3 className={styles.subtitle}>שימו לב!</h3>
                  <p>במהלך הסיור חפשו פרטים נוספים על ילדי המסתור:</p>
                </div>
                <div className={`${styles.left}`}>
                  <div className={styles.infoWrapper}>
                    <div className={`flex items-center justify-start rounded mb-2.5 w-full transition-colors ${styles.infoButton}`} >
                        <span className={`flex items-center justify-center ${styles.infoIcon}`}>
                          <Quote color={'#223A57'} />
                        </span>
                        <span className={styles.infoText}>עדויות של ניצולים</span>
                    </div>
                  </div>
                  <div className={styles.infoWrapper}>
                    <div className={`flex items-center justify-start rounded w-full transition-colors ${styles.infoButton}`} >
                        <span className={`flex items-center justify-center ${styles.infoIcon}`}>
                          <Question color={'#223A57'} />
                        </span>
                        <span className={styles.infoText}>שאלות לסקרנים</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        {screenWidth > 767 && (
          <div className={`button absolute ${styles.button}`}>
            <div className={`relative flex ${styles.magneticLink}`}>
                <Link href={'/story/'}>
                  <a 
                  onClick={() => {
                    playClick();
                  }}
                  onMouseEnter={() => {
                    playHover();
                  }}
                  className='flex items-center'>
                    <span className='text'>רוצים  לפגוש עוד סיפורים?</span>
                    <span className={`flex items-center justify-center ${styles.icon}`} style={{backgroundImage: `url(${buttonBg.src})`}}>
                        <Arrow />
                    </span>
                  </a>
                </Link>
            </div>
          </div>
        )}

        {screenWidth < 767 && (
          <div className={`mobileToaster ${styles.mobileToaster}`}>
              <div className={`text-center ${styles.toasterContent}`}>
                  <p>את הסיפורים, העדויות ותשובות לשאלות תמצאו בתערוכה המלאה.</p>
                  <p>עברו למסך מחשב והתחילו לגלות!</p>
              </div>
              <button 
              onClick={() => {
                  if (navigator.share) {
                      navigator.share({
                        title: `'במסתרים׳ ילדי מסתור בתקופת השואה. תערוכה וירטואלית.`,
                        text: 'גנזך קידוש השם מציגים: חוויה אינטראקטיבית על ילדי מסתור בתקופת השואה. למדו על פרידתם מההורים, המסתור, ההצלה והשיקום לאחר המלחמה. מותאם לבני נוער. התחילו בסיור.',
                          url: 'https://ganzach.org.il/',
                      })
                      .then(() => console.log('Successful share'))
                      .catch((error) => console.log('Error sharing', error));
                  } else {
                      console.log('Share not supported on this browser, do it the old way.');
                  }
              }}
              className={styles.toasterButton}>שלחו לי קישור למייל או לוואטסאפ</button>
          </div>
        )}
      </div>
    </>
  )
}

export default Section3